<script setup lang="ts">
/**
 * Table cell for a client gender balance: `NM / NF` in the app's
 * established gender colors (`--color-gender-men`/`--color-gender-women`),
 * matching `BusinessServiceCard`'s visitor-count badge convention.
 */
import { useI18n } from 'vue-i18n'

defineProps<{
  /** Smaller font for narrow balance columns. */
  compact?: boolean
  /** Count of male clients. */
  maleCnt: number
  /** Count of female clients. */
  femaleCnt: number
  /** Max width of the cell (CSS value). Set by DynamicTable from column config. */
  maxWidth?: string
}>()

const { t } = useI18n()
</script>

<template>
  <td
    class="gender-balance-cell"
    :class="{ 'gender-balance-cell--compact': compact }"
    :style="maxWidth ? { maxWidth: maxWidth, overflowWrap: 'break-word' } : undefined"
  >
    <span class="gender-balance-cell__men">{{ maleCnt }}{{ t('common.maleAbbr') }}</span
    ><span class="gender-balance-cell__separator">/</span
    ><span class="gender-balance-cell__women">{{ femaleCnt }}{{ t('common.femaleAbbr') }}</span>
  </td>
</template>

<style scoped>
.gender-balance-cell {
  font-family: var(--font-tufte-mono);
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.gender-balance-cell--compact {
  font-size: var(--text-tufte-sm);
}

.gender-balance-cell__men {
  color: var(--color-gender-men);
}

.gender-balance-cell__women {
  color: var(--color-gender-women);
}

.gender-balance-cell__separator {
  color: var(--color-tufte-muted);
  margin: 0 0.1rem;
}
</style>
